import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'I Love Math';
}



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/app.component.ts